module.exports = __webpack_public_path__ + "img/60.4.NH3-N.c33cf921.png";